'use strict';

angular.module('atex.dam').directive('damDownloadButton', ['DownloadService', '$window', 'configuration', function(DownloadService, $window, configuration) {
  return {
    restrict : 'ACE',
    templateUrl : 'views/dam-download.html',

    scope : {
      entries : "=?",
      buttonStyle : "=",
      buttonDisabled: '=',
      convertHtml: '=?',
      label : "="
    },
    link : function(scope, element, attr) {
      scope.types = DownloadService.getTypes();
      scope.downloading = false;

      scope.download = function() {
        var fileName;
        var ids = atex.dam.AngularUtils.getIdsArray(scope.entries);
        $window.atex.analytics('event', { e: 'download', d1: ids });
        scope.downloading = true;
        var tmp = '';
        var articles=0;
        scope.entries.forEach(function(entry, key) {
          var data = (entry._data) ? entry._data.aspects.contentData.data : (entry.data) ? entry.data.aspects.contentData.data : entry;
          if (!data) {
            console.log("DamDownloadButton: No data detected....");
            return;
          }
          var contentId = (entry._data) ? entry._data.id : (entry.data) ? entry.data.id : entry.id;
          if (contentId === undefined && entry.id !== undefined){
            contentId = entry.id;
          }
          if (!contentId) {
            console.log("DamDownloadButton: No content id detected....");
            return;
          }

          if (data.objectType === 'article') {
            var fields;
            var article = {};
            var downloadFieldList = configuration.getDownloadFieldList();
            if (downloadFieldList){
              article['fields'] = downloadFieldList.fields;
              article['fieldTypes'] = downloadFieldList.fieldTypes;
              article['fieldLabels'] = downloadFieldList.fieldLabels;
              article['fieldBreaks'] = downloadFieldList.fieldBreaks;
              article['ext'] = downloadFieldList.ext;
            }else{
              article['fields'] = 'title,shortHeadline,reporter1,reporter2,reporter3,body,newsBox1,newsBox2,newsBox3,newsBox4,newsBox5,newsBox6,newsBox7,newsBox8,newsBox9';
              article['fieldTypes'] = 'string,string,string,string,string,string,string,string,string,string,string,string,string,string';
              article['fieldLabels'] = '0,1,2,3,4,5,6,7,8,9,10,11,12,13,14';
              article['fieldBreaks'] = '1,1,1,1,1,1,1,1,1,1,1,1,1,1,1';
              article['ext'] = '.html';
            }
            if (scope.convertHtml) {
              if (!tmp) {
                tmp = '<!doctype html><html><head><meta charset="UTF-8"></head><body>';
              }
              var tagToRemoveFinder = configuration.getEscapeTagOnDownloadArticleHtml();
              scope.types['p.DamArticle'] = article;
              fields = scope.types['p.DamArticle'].fields.split(',');
              var fieldTypes = scope.types['p.DamArticle'].fieldTypes.split(',');
              fileName = "articles.html";
              fields.forEach(function(field, key) {
                var value = ( data[field] !== undefined ) ? ( (data[field].text !== undefined) ? data[field].text : data[field]) : "";
                if((field === 'title' || field === 'name') && value !== undefined && value !== "") {
                  fileName = value + '.html';

                } else {
                  var fieldType = fieldTypes[key];
                  if (fieldType === 'date') {
                    var d = new Date(parseInt(value));
                    var month = d.getMonth() + 1;
                    var dateValue = month + "/" + d.getDate() + "/" + d.getFullYear();
                    tmp += field + "\n" + dateValue + '\n\n';
                  }  else {
                    var textValue = stripHtmlTagByParam(value, tagToRemoveFinder);
                    if(field === 'shortHeadline') {
                      textValue = '<h1>' + textValue + '</h1>';
                    }
                    tmp += textValue + '<br />';
                  }
                }
              });
            }else{
              fields = scope.types['p.DamArticle'].fields.split(',');
              tmp += (++articles)+"-Id: "+contentId+"\n\n";
              fields.forEach(function(field, key) {
                var value = ( data[field] !== undefined ) ? ( (data[field].text !== undefined) ? data[field].text : data[field]) : "";
                tmp += field + "\n" + value + '\n\n';
              });
            }
          } else {
            DownloadService.binary(contentId).then(function(e) {
              scope.downloading = false;
            }).then(null, function(error) {
              scope.downloading = false;
            });
          }

          if( tmp && (key === (scope.entries.length-1)) ) {
            if (scope.convertHtml) {
              tmp += "</body></html>";
            }
            DownloadService.text(tmp, fileName !== undefined ? fileName : 'articles.txt').then(function(e) {
              scope.downloading = false;
            });
          }
        });
      };
      function stripHtmlTagByParam(html, tagToRemoveFinder)
      {
        var tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        if (tagToRemoveFinder){
          var elements = tmp.querySelectorAll(tagToRemoveFinder);
          elements.forEach(function(e) {
            e.parentElement.removeChild(e);
          });
          return tmp.innerHTML;
        }else{
          return tmp.innerHTML || "";
        }
      }
    }
  };
}]);
